import { render } from "./SingleProduct.vue?vue&type=template&id=6695d72e&scoped=true"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"

import "./SingleProduct.vue?vue&type=style&index=0&id=6695d72e&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6695d72e"]])

export default __exports__